import { render, staticRenderFns } from "./TitledIcon.vue?vue&type=template&id=5d614f32"
import script from "./TitledIcon.vue?vue&type=script&lang=ts"
export * from "./TitledIcon.vue?vue&type=script&lang=ts"
import style0 from "./TitledIcon.vue?vue&type=style&index=0&id=5d614f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports